import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-details-fallback-widget',
  templateUrl: './student-details-fallback-widget.component.html',
  styleUrls: ['./student-details-fallback-widget.component.scss']
})
export class StudentDetailsFallbackWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
